<template>
  <div class="login_container">
    <b-row class="login-row">
      <b-col class="text-center">
        <img src="@/assets/logo.png" width="100" height="100" />
        <h3>Connectez-vous à J.L. AI®</h3>
      </b-col>
    </b-row>

    <b-row v-if="errorMessage" class="login-row mt-4">
      <b-col>
        <b-alert show variant="danger">
          {{ errorMessage }}
        </b-alert>
      </b-col>
    </b-row>

    <b-row class="login-row mt-4">
      <b-col>
        <b-form class="login" @submit="triggerLogin">
          <b-form-group class="login__input p-3">
            <b-row>
              <b-col cols="1" class="login__input-previous">
                <img
                  v-if="currentStep > 0"
                  @click="currentStep--"
                  :src="require(`@/assets/icons/previous.svg`)"
                  class="cursor-pointer mt-2"
                  height="20"
                  width="20"
                />
              </b-col>

              <b-col>
                <b-form-input
                  v-if="currentStep === 0"
                  v-model="email"
                  @keydown.enter="nextStep"
                  type="email"
                  placeholder="Enter your email address"
                  required
                ></b-form-input>

                <b-form-input
                  v-else-if="currentStep === 1"
                  v-model="password"
                  @keydown.enter="nextStep"
                  type="password"
                  placeholder="Enter your password"
                  required
                ></b-form-input>
              </b-col>

              <b-col cols="1" class="registration__input-next">
                <spinner v-if="isSending" size="sm" />

                <img
                  @click="nextStep"
                  v-else-if="currentStep === 1"
                  :src="require(`@/assets/icons/check-mark.svg`)"
                  class="float-right cursor-pointer mt-2"
                  height="20"
                  width="20"
                />

                <img
                  @click="nextStep"
                  v-else
                  :src="require(`@/assets/icons/next.svg`)"
                  class="float-right cursor-pointer mt-2"
                  height="20"
                  width="20"
                />
              </b-col>
            </b-row>
          </b-form-group>

          <div v-if="currentStep === 0">
            <b-row>
              <b-col>
                <div class="input__error" v-if="!$v.email.required">Le champ est requis.</div>
                <div class="input__error" v-if="!$v.email.email">Must be a valid email</div>
              </b-col>
            </b-row>
          </div>

          <div v-if="currentStep === 1">
            <div class="input__error" v-if="!$v.password.required">Le champ est requis.</div>
          </div>

          <p class="mt-4 text-center">
            <em>Pas encore de compte ? <router-link :to="{ name: 'register' }">Cliquez ici.</router-link>.</em><br />
            <em>Mot de passe oublié ? <router-link :to="{ name: 'password' }">Cliquez ici.</router-link>.</em><br />
          </p>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { LOGIN, GET_AUTH } from "@/store/actions";

import { BRow, BCol, BForm, BFormGroup, BFormInput, BAlert } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import Spinner from "@/components/Spinner";
import { GET_MEMBER_BY_ID } from "../../store/actions";

export default {
  name: "Login",
  components: { BRow, BCol, BForm, BFormGroup, BFormInput, BAlert, Spinner },
  mixins: [validationMixin],
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters("auth", ["isAuthenticated", "hasErrors", "isBanned"]),
  },
  data: () => ({
    email: null,
    password: null,

    currentStep: 0,
    errorMessage: null,

    isSending: false,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.isBanned) next({ name: "login" });
    });
  },
  methods: {
    ...mapActions("auth", { login: LOGIN, getAuth: GET_AUTH }),
    ...mapActions("community", { getMemberById: GET_MEMBER_BY_ID }),
    async triggerLogin(event) {
      if (event) event.preventDefault();
      this.errorMessage = null;
      this.isSending = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.hasSubmitError = true;
        this.isSending = false;
        return;
      }

      const { email, password } = this;

      const result = await this.login({ email, password });
      if (this.isAuthenticated) {
        await this.getAuth();
        const { uid } = this.user;
        const memberData = await this.getMemberById({ uid });
        const { isBanned } = memberData;
        if (isBanned) {
          this.errorMessage = "You are suspended";
        } else {
          this.$router.push({ name: "dashboard" });
        }
      } else {
        this.errorMessage = result;
        this.isSending = false;
      }
    },
    nextStep(event) {
      event.preventDefault();

      if (this.currentStep === 0) {
        if (this.$v.email.required && this.$v.email.email) this.currentStep++;
      } else if (this.currentStep === 1) {
        if (this.$v.password.required) this.triggerLogin();
      }
    },
  },

  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>

<style lang="scss" scoped>
.login_container {
  padding-top: 30vh;
}
.login-row {
  margin: auto;
  width: 100%;
  max-width: 700px;
}
.login__input {
  border: 1px solid #292037;
  border-radius: 15px;
  background-color: #211932;
  color: #9593a2;
  font-size: 18px;

  input {
    width: 90%;
    background: transparent;
    border: 0px;
    color: #fff;
    font-size: 18px;
  }

  .login__input-next {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    transition: transform 0.7s ease-in-out;
  }
}

@media screen and (max-width: 576px) {
  .login_container {
    padding-top: 18vh;
  }
}
</style>
